import { Input, Modal, PrimaryButton, PrimaryCardButton } from '@cb/apricot-react';
import { LinearProgress } from '@mui/material';
import { ChangeEventHandler, FC, useEffect, useState } from 'react';

import { useToasts } from 'src/hooks';
import { getValidatedSchoolName } from '../../utils';

interface NewSchoolModalProps {
  isOpen?: boolean;
  isLoading?: boolean;
  onClose: VoidFunction;
  onSubmit: (schoolName: string) => void;
}

const NewSchoolModal: FC<NewSchoolModalProps> = ({ isOpen, isLoading, onClose, onSubmit }) => {
  const [schoolName, setSchoolName] = useState('');

  const { errorMessage, render: renderToasts, toastErrorMessage } = useToasts();

  const handleChangeSchoolName: ChangeEventHandler<HTMLInputElement> = (event) => {
    setSchoolName(event.target.value);
  };

  useEffect(() => {
    setSchoolName('');
  }, [isOpen]);

  const handleSubmit = () => {
    if (!schoolName) {
      toastErrorMessage('Please fill out the School Name.');
    } else {
      toastErrorMessage(null);

      const validatedSchoolName = getValidatedSchoolName(schoolName);

      onSubmit(validatedSchoolName);
    }
  };

  return (
    // @ts-ignore
    <Modal
      title="Create a new School Code Form"
      actions={[
        <PrimaryButton key="submit" onClick={handleSubmit}>
          Submit
        </PrimaryButton>,
        <PrimaryCardButton key="close" onClick={onClose}>
          Close
        </PrimaryCardButton>,
      ]}
      closeButton={false}
      open={isOpen}
      onClose={onClose}
      withHeader>
      {isLoading && <LinearProgress />}

      {renderToasts()}

      <div className="display-flex flex-column cb-padding-top-8">
        <Input
          floating={false}
          label="School/Entity Name"
          required
          placeholder="School/Entity Name"
          onChange={handleChangeSchoolName}
          value={schoolName}
          validation={errorMessage ? 'error' : undefined}
          validationMsg={errorMessage ?? undefined}
        />
      </div>
    </Modal>
  );
};

export default NewSchoolModal;
